module.exports = __webpack_public_path__ + "img/delete-not-fill.ce7ffe85.svg";